import React from 'react'
import { EfoPostalCode } from './EfoPostalCode'

/**
 * PF転換フォームの住まい（住所入力）ステップを表示する。
 *
 * @returns 住所入力フォーム（DEV-3483 でBパターンの EfoPostalCode を本採用）
 */
export const JobSeekerPostalCode = () => <EfoPostalCode />
